import { Directive, inject } from '@angular/core';
import { CountryService } from '@app/core/services/country.service';
import { AutoComplete, AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { map, switchMap } from 'rxjs';

@Directive({
  selector: '[appCountryAutocomplete]',
  standalone: true
})
export class CountryAutocompleteDirective {
  private _hostComponent = inject(AutoComplete);
  private _countryService = inject(CountryService);

  constructor() {
    this._hostComponent.completeMethod
      .asObservable()
      .pipe(switchMap((x) => this.searchCountry(x)))
      .subscribe((countries) => (this._hostComponent.suggestions = countries));
  }

  searchCountry(event: AutoCompleteCompleteEvent) {
    return this._countryService.getAllCountries().pipe(
      map((x) =>
        x
          .filter((v) => !event.query || v.countryName.toLowerCase().includes(event.query.toLowerCase()))
          .map((x) => {
            return {
              label: x.countryName,
              uid: x.uid,
              flagIcon: `fi fi-${x.code.toLowerCase()}`
            };
          })
      )
    );
  }
}
